import WithGASetup from '../../../components/WithGASetup';
import AuthContext from '../../../context/AuthContext';
import ContactUsPage from './ContactUsPage';

export default WithGASetup(ContactUsPage, AuthContext);
